<template>
    <fragment>
        <span class="help-icon">
            <i v-on:click.prevent="toggleInfoBox($event, true)" class="fas fa-question-circle"></i>
            <div class="help-information" :class="{'is-open-helpbox': showInfoBox}">
                <span class="close-popup" v-on:click.prevent="toggleInfoBox($event, false)"><i class="fas fa-times"></i></span>
                <p v-html="info"></p>
            </div>
            <div class="click-box" :class="{'is-open-clickbox': showInfoBox}"></div>
        </span>
    </fragment>
</template>

<script>

import dataStore from "../../store";
import globalFunctions from "../../globalFunctions";

import { Fragment } from 'vue-fragment'

export default {

    data() {
        return {
            dataStore,
            globalFunctions,
            showInfoBox : false
        }
    },

    props : {
        info : String
    },

    components : {
        Fragment
    },

    methods : {

        toggleInfoBox: function(e, open) {

            let helpBoxes = document.getElementsByClassName('is-open-helpbox')

            for (let element of helpBoxes) {
                element.classList.remove('is-open-helpbox')
            }

            if(open) {
                this.showInfoBox = true;
                e.target.nextElementSibling.classList.add('is-open-helpbox')
                e.target.parentNode.lastChild.classList.add('is-open-clickbox')

            } else {
                this.showInfoBox = false;
            }

            this.$emit('help-box-open', this.showInfoBox)

        }
    }

};
</script>
